export default __webpack_public_path__ + "static/media/more.7cdbe064.svg";